
import { useEffect, useState, useRef } from 'react';

export default function EncryptionSpecs() {
  const [animated, setAnimated] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setAnimated(true);
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const specs = [
    {
      title: 'In Transit',
      details: 'TLS 1.3, AES-256-GCM, perfect forward secrecy',
    },
    {
      title: 'At Rest',
      details: 'AES-256, hardware security modules (account data only)',
    },
    {
      title: 'Processing',
      details: 'RAM only, no disk I/O, memory cleared on termination',
    },
  ];

  return (
    <section ref={sectionRef} className="relative py-24 bg-[#0a0a0c]">
      <div className="max-w-[1200px] mx-auto px-6 sm:px-8">
        <h2 className="text-white text-3xl sm:text-[42px] font-black text-center mb-16 sm:mb-20">
          Encryption Specs
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8">
          {specs.map((spec, index) => (
            <div
              key={index}
              className={`p-6 sm:p-8 bg-[#0f0f11] border border-[#1a1a1c] rounded-xl transition-all duration-700 hover:border-[#06b6d4] hover:shadow-[0_0_30px_rgba(6,182,212,0.15)] ${
                animated ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'
              }`}
              style={{ transitionDelay: `${index * 150}ms` }}
            >
              <h3 className="text-[#06b6d4] text-xl sm:text-2xl font-bold mb-4">
                {spec.title}
              </h3>
              <p className="text-[#d4d4d8] text-base sm:text-lg leading-relaxed">
                {spec.details}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
